export type Dir5 = 'S' | 'R' | 'F' | 'B' | 'L';
export interface DirChoice { dir: string; flipX: boolean; }

type Octant = 'E' | 'SE' | 'S' | 'SW' | 'W' | 'NW' | 'N' | 'NE';

// Octant de (fx, fy), y vers le bas : E = 0 degré, S = 90 degrés.
function octant(fx: number, fy: number): Octant {
  if (fx === 0 && fy === 0) return 'E';
  const a = (Math.atan2(fy, fx) * 180) / Math.PI;
  if (a >= -22.5 && a < 22.5) return 'E';
  if (a >= 22.5 && a < 67.5) return 'SE';
  if (a >= 67.5 && a < 112.5) return 'S';
  if (a >= 112.5 && a < 157.5) return 'SW';
  if (a >= 157.5 || a < -157.5) return 'W';
  if (a >= -157.5 && a < -112.5) return 'NW';
  if (a >= -112.5 && a < -67.5) return 'N';
  return 'NE';
}

const FIVE: Record<Octant, DirChoice> = {
  E: { dir: 'S', flipX: false }, SE: { dir: 'R', flipX: false }, S: { dir: 'F', flipX: false }, SW: { dir: 'R', flipX: true },
  W: { dir: 'S', flipX: true }, NW: { dir: 'L', flipX: false }, N: { dir: 'B', flipX: false }, NE: { dir: 'L', flipX: true },
};

/** Direction dessinée et miroir pour un facing (fx, fy), selon les directions disponibles de l'entité. */
export function chooseDirection(fx: number, fy: number, available: readonly string[]): DirChoice {
  if (available.includes('F') && available.includes('B') && available.includes('S')) return FIVE[octant(fx, fy)];
  // 2 directions : R regarde vers le bas-droite, L vers le haut-gauche
  if (fy >= 0) return { dir: 'R', flipX: fx < 0 };
  return { dir: 'L', flipX: fx > 0 };
}
